import React, { useState, useEffect } from 'react';
import { db } from '../firebase/firestore';
import { collection, setDoc, updateDoc, deleteDoc, doc, getDocs, query, orderBy, limit } from "firebase/firestore";
import Spinner from '../Components/Spinner';

const gameUrls = [
  { label: "Auto Mining", value: "/farm" },
  { label: "Super Mining", value: "/moonbix" },
  { label: "Spin", value: "/roulette" },
  { label: "FatMonkey", value: "/FatBoy" },
  { label: "Jungle Invaders", value: "/aliens" },
];

const AdminGameEvents = () => {
  const [events, setEvents] = useState([]);
  const [eventData, setEventData] = useState({
    name: '',
    description: '',
    icon: '',
    rewards: '',
    url: '',
    startDate: '',
    endDate: '',
  });
  const [leaderboards, setLeaderboards] = useState({});
  const [showEventInputs, setShowEventInputs] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [currentEventId, setCurrentEventId] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    const querySnapshot = await getDocs(collection(db, "gameEvents"));
    const eventsList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setEvents(eventsList);
    setLoading(false);
    eventsList.forEach(event => fetchLeaderboard(event.id));
  };

  const fetchLeaderboard = async (eventId) => {
    const leaderboardQuery = query(
      collection(db, `gameEvents/${eventId}/leaderboard`),
      orderBy('points', 'desc'),
      limit(10)
    );
    const querySnapshot = await getDocs(leaderboardQuery);
    const leaderboardData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setLeaderboards(prev => ({ ...prev, [eventId]: leaderboardData }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEventData({
      ...eventData,
      [name]: value
    });
  };

  const handleAddEvent = async () => {
    try {
      const newEventRef = doc(collection(db, "gameEvents"));
      await setDoc(newEventRef, eventData);
      setSuccessMessage('Event successfully added!');
      resetForm();
      fetchEvents();
    } catch (e) {
      console.error("Error adding event: ", e);
    }
  };

  const handleUpdateEvent = async () => {
    try {
      const eventDoc = doc(db, "gameEvents", currentEventId);
      await updateDoc(eventDoc, eventData);
      setSuccessMessage('Event successfully updated!');
      resetForm();
      fetchEvents();
    } catch (e) {
      console.error("Error updating event: ", e);
    }
  };

  const handleDeleteEvent = async (id) => {
    try {
      const eventDoc = doc(db, "gameEvents", id);
      await deleteDoc(eventDoc);
      fetchEvents();
    } catch (e) {
      console.error("Error deleting event: ", e);
    }
  };

  const resetForm = () => {
    setEventData({ name: '', description: '', icon: '', rewards: '', url: '', startDate: '', endDate: '' });
    setShowEventInputs(false);
    setIsEditing(false);
    setCurrentEventId('');
  };

  const handleEditEvent = (event) => {
    setEventData(event);
    setShowEventInputs(true);
    setIsEditing(true);
    setCurrentEventId(event.id);
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="w-full flex flex-col h-screen overflow-y-auto p-4">
          <button
            onClick={() => setShowEventInputs(!showEventInputs)}
            className="bg-green-500 text-white font-semibold px-4 py-2 rounded-md mb-4"
          >
            {showEventInputs ? 'Cancel' : 'New Event'}
          </button>

          {showEventInputs && (
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium mb-1">Event Name</label>
                <input
                  type="text"
                  name="name"
                  value={eventData.name}
                  onChange={handleInputChange}
                  placeholder="Event Name"
                  className="border rounded w-full px-2 py-1 text-black"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Description</label>
                <input
                  type="text"
                  name="description"
                  value={eventData.description}
                  onChange={handleInputChange}
                  placeholder="Description"
                  className="border rounded w-full px-2 py-1 text-black"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Icon URL</label>
                <input
                  type="text"
                  name="icon"
                  value={eventData.icon}
                  onChange={handleInputChange}
                  placeholder="Icon URL"
                  className="border rounded w-full px-2 py-1 text-black"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Rewards</label>
                <input
                  type="text"
                  name="rewards"
                  value={eventData.rewards}
                  onChange={handleInputChange}
                  placeholder="Rewards"
                  className="border rounded w-full px-2 py-1 text-black"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Game URL</label>
                <select
                  name="url"
                  value={eventData.url}
                  onChange={handleInputChange}
                  className="border rounded w-full px-2 py-1 text-black"
                >
                  <option value="">Select Game URL</option>
                  {gameUrls.map((game) => (
                    <option key={game.value} value={game.value}>
                      {game.label}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Start Date</label>
                <input
                  type="date"
                  name="startDate"
                  value={eventData.startDate}
                  onChange={handleInputChange}
                  className="border rounded w-full px-2 py-1 text-black"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">End Date</label>
                <input
                  type="date"
                  name="endDate"
                  value={eventData.endDate}
                  onChange={handleInputChange}
                  className="border rounded w-full px-2 py-1 text-black"
                />
              </div>
              <div className="col-span-2">
                <button
                  onClick={isEditing ? handleUpdateEvent : handleAddEvent}
                  className="bg-blue-500 text-white font-semibold px-4 py-2 rounded-md w-full"
                >
                  {isEditing ? 'Update Event' : 'Add Event'}
                </button>
              </div>
            </div>
          )}

          {successMessage && <div className="text-green-500 mb-4">{successMessage}</div>}

          <div className="grid grid-cols-3 gap-4">
            {events.map((event) => (
              <div key={event.id} className="bg-gray-800 text-white p-4 rounded-md shadow">
                <h3 className="font-bold text-xl">{event.name}</h3>
                <p>{event.description}</p>
                <p className="text-sm text-gray-400">{event.url}</p>
                <p className="text-sm text-gray-400">Start: {event.startDate || 'N/A'}</p>
                <p className="text-sm text-gray-400">End: {event.endDate || 'N/A'}</p>
                <div className="flex space-x-2 mt-4">
                  <button
                    onClick={() => handleEditEvent(event)}
                    className="bg-yellow-500 text-black px-2 py-1 rounded"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDeleteEvent(event.id)}
                    className="bg-red-500 text-white px-2 py-1 rounded"
                  >
                    Delete
                  </button>
                </div>

                {/* Leaderboard */}
                <div className="mt-4">
                  <h4 className="text-lg font-bold">Leaderboard</h4>
                  <ul className="mt-2">
                    {(leaderboards[event.id] || []).map((player, index) => (
                      <li key={player.id} className="flex justify-between py-1 border-b border-gray-700">
                        <span>{index + 1}. {player.name}</span>
                        <span>{player.points} pts</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default AdminGameEvents;
